module.exports = __webpack_public_path__ + "static/img/w1.e7032b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/w1.png
// module id = OHlB
// module chunks = 0